// extracted by mini-css-extract-plugin
export default {"global-header-logo":"CustomHeaderLogo__global-header-logo___AtRyi","custom-nav-logo":"CustomHeaderLogo__custom-nav-logo____hxtL"};